// extracted by mini-css-extract-plugin
export default {"root":"appLogo_root__PI3yP","stripes-animation-background-keyframes":"appLogo_stripes-animation-background-keyframes__poqxd"};